import dayjs from 'dayjs';

import { downloadPdf } from 'helpers/utils';

import PDFTemplate from './PDFTemplate';

interface CustomPageSize {
  /**
   * Page width in `pt`.
   */
  width: number;

  /**
   * Page height in `pt`, or `auto` to adapt the page height to the document's content
   * (the document will always have a single page).
   */
  height: number | 'auto';
}

type PredefinedPageSize =
  | '4A0'
  | '2A0'
  | 'A0'
  | 'A1'
  | 'A2'
  | 'A3'
  | 'A4'
  | 'A5'
  | 'A6'
  | 'A7'
  | 'A8'
  | 'A9'
  | 'A10'
  | 'B0'
  | 'B1'
  | 'B2'
  | 'B3'
  | 'B4'
  | 'B5'
  | 'B6'
  | 'B7'
  | 'B8'
  | 'B9'
  | 'B10'
  | 'C0'
  | 'C1'
  | 'C2'
  | 'C3'
  | 'C4'
  | 'C5'
  | 'C6'
  | 'C7'
  | 'C8'
  | 'C9'
  | 'C10'
  | 'RA1'
  | 'RA2'
  | 'RA3'
  | 'RA4'
  | 'SRA1'
  | 'SRA2'
  | 'SRA3'
  | 'SRA4'
  | 'EXECUTIVE'
  | 'FOLIO'
  | 'LEGAL'
  | 'LETTER'
  | 'TABLOID';

type Props = {
  data?: object[];
  dataHeaders?: { label: string; key: string }[];
  fileName?: string;
  pageSize?: CustomPageSize | PredefinedPageSize;
  width?: 'auto' | '*' | string;
  widthLength?: number;
  isLandscape?: boolean;
};

const ExportPDF = (props: Props) => {
  const exportPDF = () => {
    downloadPdf(
      `${props.fileName ? props.fileName : 'Clientes'}_${dayjs().format(
        'DD/MM/YYYY'
      )}.pdf`,
      // Forma en la que se reciben los datos en el PDF
      // PDFTemplateClient(data, headers, length de la data para ver el width de la tabla)
      // los headers tiene que tener la forma de  { label: string; key: string}
      // ({ data: props.data}, { dataHeaders: props.dataHeaders})
      PDFTemplate({
        data: props?.data,
        headers: props.dataHeaders,
        pageSize: props?.pageSize,
        isLandscape: props?.isLandscape,
        widthLength: props?.dataHeaders?.length
      })
    );
  };

  const handleExportPDF = () => {
    exportPDF();
  };

  return handleExportPDF();
};

export default ExportPDF;
